// Chakra imports
import { Box, Button, Flex, Text, Icon, useColorModeValue } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card';
import IconBox from 'components/icons/IconBox';
import Moment from 'react-moment';
import { Link as RouterLink } from 'react-router-dom';

// Assets
import { MdMailOutline } from 'react-icons/md';
import { EmailToSendRow, EMAILS_WINDOW_DAYS } from 'views/admin/default/dashboardData';

// Interventions récentes dont l'email au client n'est pas encore parti
export default function EmailsToSend(props: { rows: EmailToSendRow[]; total: number; [x: string]: any }) {
	const { rows, total, ...rest } = props;

	// Chakra Color Mode
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const boxBg = useColorModeValue('secondaryGray.300', 'navy.700');
	const brandColor = useColorModeValue('brand.500', 'brand.400');
	return (
		<Card p='20px' alignItems='center' flexDirection='column' w='100%' {...rest}>
			<Flex alignItems='center' w='100%' mb='30px'>
				<IconBox
					me='12px'
					w='38px'
					h='38px'
					bg={boxBg}
					icon={<Icon as={MdMailOutline} color={brandColor} w='24px' h='24px' />}
				/>

				<Flex direction='column'>
					<Text color={textColor} fontSize='lg' fontWeight='700'>
						Emails à envoyer ({total})
					</Text>
					<Text color='secondaryGray.600' fontSize='xs' fontWeight='500'>
						{EMAILS_WINDOW_DAYS} derniers jours
					</Text>
				</Flex>
			</Flex>
			<Box px='11px' w='100%'>
				{rows.length === 0 && (
					<Text color='secondaryGray.600' fontSize='sm' mb='20px'>
						Aucun email en attente
					</Text>
				)}
				{rows.map((row) => (
					<Flex key={row.id} w='100%' justify='space-between' align='center' mb='20px'>
						<Flex direction='column' me='16px' minW='0'>
							<Text fontWeight='bold' color={textColor} fontSize='md' textAlign='start' noOfLines={1}>
								{row.client}
							</Text>
							<Text color='secondaryGray.600' fontSize='sm' noOfLines={1}>
								{row.site}
							</Text>
						</Flex>
						<Text color='secondaryGray.600' fontSize='sm' fontWeight='500' flexShrink={0}>
							<Moment format='DD/MM/YYYY'>{row.date}</Moment>
						</Text>
					</Flex>
				))}
				<Button as={RouterLink} to='/admin/interventions' size='sm' variant='ghost' colorScheme='teal' w='100%'>
					Voir les interventions
				</Button>
			</Box>
		</Card>
	);
}
